class Notify {

    constructor() {
        this.stateManager = window.AppState;
    }

    renderNotifications(notifications) {
        const container = document.getElementById('notifications-container');
        container.innerHTML = '';

        // @todo сделать не перерисоввывание, а добавление
        notifications.forEach(notification => {
            const element = document.createElement('div');
            element.className = `notification ${notification.type}`;
            element.dataset.id = notification.id;
            element.innerHTML = '<p>' + notification.message + '</p>'
                + '<button class="close-notification" data-id="' + notification.id + '"><i class="fas fa-times"></i></button>';
            container.appendChild(element);
        });

        document.querySelectorAll('.close-notification').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const currentNotifications = window.AppState.getState().ui.notifications;
                const id = btn.getAttribute('data-id');
                window.AppState.updateState(state => ({
                    ui: {
                        ...state.ui,
                        notifications: currentNotifications.filter(n => n.id !== parseInt(id))
                    }
                }));

                document.querySelector('.notification[data-id="' + id + '"]').remove();
            });
        });
    }

    notify(notification) {
        if (!notification.id) notification.id = Date.now();
        this.stateManager.updateState(state => ({
            ui: {
                ...state.ui,
                notifications: state.ui.notifications.concat([notification])
            }
        }));
        this.renderNotifications(this.stateManager.state.ui.notifications);
    }

    errorNotify(message) {
        this.notify({ message, type: 'error' });
    }

    doneNotify(message) {
        this.notify({ message, type: 'success' });
    }

}

window.__notify = new Notify();
